export const VOICEBOX_RESPONSE_MESSAGES_COOKIE = 'voicebox-response-messages';
export const VOICEBOX_RESPONSE_SPARQL_COOKIE = 'voicebox-response-sparql';

export const getFuzzySeededValue = <T>(
  values: Record<string, T>,
  query: string
): T | undefined => {
  const trimmed = query.trim();
  return (
    values[trimmed] ||
    values[trimmed.toLowerCase()] ||
    values[trimmed.replace(/[^\w\s]/gi, '')] ||
    values[trimmed.toLowerCase().replace(/[^\w\s]/gi, '')]
  );
};

export const getSeededVoicebox = (
  cookieName: string,
  messages: Record<string, string>,
  query: string
): string => {
  const allMessages = { ...messages };
  try {
    const cookieMatch = document.cookie.match(
      `(^|;)\\s*${cookieName}\\s*=\\s*([^;]+)`
    );
    const cookie = (cookieMatch && (cookieMatch.pop() as string)) || '{}';
    Object.assign(allMessages, JSON.parse(cookie));
  } catch (err) {
    console.warn('Problem loading messages', err);
  }

  return getFuzzySeededValue(allMessages, query) || '';
};

export const getSeededVoiceboxResponseMessage = (
  messages: Record<string, string>,
  query: string
): string =>
  getSeededVoicebox(VOICEBOX_RESPONSE_MESSAGES_COOKIE, messages, query);

export const getSeededVoiceboxResponseSparql = (
  messages: Record<string, string>,
  query: string
): string =>
  getSeededVoicebox(VOICEBOX_RESPONSE_SPARQL_COOKIE, messages, query);
